import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

export const useAddProductsToCategoryMutation = (id: any) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (payload: string[]) =>
      axiosInstance
        .patch(`/products/categories/${id}/add-to-category`, {
          products: payload,
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      message.success(data?.message);
      navigate("/product-management");
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
